import { checkIsAgentSubdomain } from "@holisto-web/sentry";
import { wrapCreateBrowserRouterV7 } from "@sentry/react";

type CreateBrowserRouter = typeof import("react-router").createBrowserRouter;

export const wrapSentryCreateBrowserRouter = (createBrowserRouter: CreateBrowserRouter): CreateBrowserRouter => {
  if (typeof window !== "undefined" && checkIsAgentSubdomain(window.location.hostname)) {
    return createBrowserRouter;
  }

  return wrapCreateBrowserRouterV7(createBrowserRouter) as CreateBrowserRouter;
};
